export const CHECK_IN_HISTORY_TYPE_FILTER = {
  ALL: 'all',
  STUDENT: 'student',
  VOLUNTEER: 'volunteer',
} as const;

export type CheckInHistoryTypeFilter =
  (typeof CHECK_IN_HISTORY_TYPE_FILTER)[keyof typeof CHECK_IN_HISTORY_TYPE_FILTER];

export type CheckInHistoryPersonType =
  | typeof CHECK_IN_HISTORY_TYPE_FILTER.STUDENT
  | typeof CHECK_IN_HISTORY_TYPE_FILTER.VOLUNTEER;
